import { isPlainObject } from 'is-plain-object'
import { stringify } from 'query-string'

type Query = Record<string, any>

export const createQuery = (
  query: Query,
  trimQuery = false,
  arrayInFormatWithDuplicatedKeys = false,
) => {
  const queryString =
    query && isPlainObject(query)
      ? stringify(query, {
          arrayFormat: arrayInFormatWithDuplicatedKeys ? 'none' : 'comma',
        })
      : ''

  if (!trimQuery && queryString) {
    return `?${queryString}`
  }

  return queryString
}
